import React, { Component } from "react"
import PropTypes from "prop-types"
import isEqual from "lodash/isEqual"
import Highcharts from "highcharts"
import Exporting from "highcharts/modules/exporting"
import HighchartsMore from "highcharts/highcharts-more"
import SolidGauge from "highcharts/modules/solid-gauge.src"
import { translate } from "react-i18next"
import ItemNameValueShape from "../../../state/shapes/ItemNameValueShape"
import { CHARTS } from "../../../constants"

class GaugeChart extends Component {
  componentDidMount = () => {
    this.createChart()
  }

  shouldComponentUpdate = nextProps => {
    return !isEqual(this.props.data, nextProps.data)
  }

  componentDidUpdate = () => {
    this.createChart()
  }

  componentWillUnmount = () => {
    this.chart.destroy()
  }

  createChart = () => {
    // Get the element into which to insert the chart
    const chartContainer = this.chartContainerRef
    const chartData = [
      {
        name: this.props.t(this.props.data.itemName),
        y: this.props.data.value
      }
    ]
    const { t, titleKey, labelKey, subtitleKey } = this.props
    const gaugeColours = [CHARTS.getRandomColour(titleKey)]

    const labelText = labelKey
      ? `<span style="font-weight: normal; text-transform: uppercase;">${t(labelKey)}</span>`
      : ""

    const labelFormat = `<div style='text-align:center'><span style='font-size:25px;'>{y}%</span><br/>${labelText}</div>`

    // Initialise high charts more and SolidGauge as they are required
    // for this chart type.
    HighchartsMore(Highcharts)
    SolidGauge(Highcharts)
    Exporting(Highcharts)
    // Create the chart
    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: chartContainer,
        height: CHARTS.standardHeight,
        type: "solidgauge",
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false
      },
      lang: {
        contextButtonTitle: t("Common.ChartDownloadOptions")
      },
      credits: {
        enabled: false
      },
      pane: {
        center: ["50%", "70%"],
        size: "90%",
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: null,
          innerRadius: "90%",
          outerRadius: "110%",
          shape: "arc"
        }
      },
      colors: gaugeColours,
      title: {
        text: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        y: 15
      },
      subtitle: {
        text: subtitleKey != null && subtitleKey.length > 0 ? t(subtitleKey) : null,
        y: 30
      },
      yAxis: {
        tickWidth: 2,
        tickLength: 7,
        offset: -18,
        minorTicks: false,
        lineWidth: 0,
        tickInterval: 25,
        labels: {
          y: -4,
          format: "{value}%",
          distance: -23
        },
        min: 0,
        max: 100,
        minColor: gaugeColours[0],
        maxColor: gaugeColours[0],
        stops: this.props.stopsValues
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        series: {
          animation: CHARTS.animationEnabled
        }
      },
      series: [
        {
          name: null,
          data: chartData,
          lineWidth: 0,
          dataLabels: {
            color: "#455a64",
            borderWidth: 0,
            format: labelFormat,
            y: -18,
            useHTML: true,
            verticalAlign: "middle"
          },
          innerRadius: "90%",
          radius: "110%"
        }
      ],
      exporting: {
        enabled: CHARTS.exportEnabled,
        buttons: {
          contextButton: {
            menuItems: CHARTS.exportButtons
          }
        },
        filename: titleKey != null && titleKey.length > 0 ? t(titleKey) : null
      }
    })
  }

  render() {
    return (
      <div
        className="chart-container col-md-12"
        ref={c => {
          this.chartContainerRef = c
        }}
      />
    )
  }
}

GaugeChart.propTypes = {
  data: PropTypes.shape(ItemNameValueShape).isRequired,
  stopsValues: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))
  ),
  t: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
  labelKey: PropTypes.string,
  subtitleKey: PropTypes.string
}

GaugeChart.defaultProps = {
  stopsValues: null,
  titleKey: "",
  labelKey: null,
  subtitleKey: ""
}

export default translate()(GaugeChart)



// WEBPACK FOOTER //
// ./src/components/charts/generic/GaugeChart.jsx